'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../../tslib.es6-130a177d.js');
var React = require('react');
var styled = require('styled-components');
var Picture_index = require('../../../Picture/index.js');
require('../../../Product.styles-8bd9554e.js');
var Product_ProductImage_index = require('../../../Product/ProductImage/index.js');
require('../../../Product/ProductInfoBox/index.js');
require('../../../Product/PriceRenderer/index.js');
var viewport_utils = require('../../../viewport.utils-0c2b4e2b.js');
var imageSizeConfigs = require('../../../imageSizeConfigs-192d99c9.js');
var imageWidths = require('../../../imageWidths-0e171afa.js');
var useImageTagFormatter$1 = require('../../../useImageTagFormatter-f52f46f2.js');
var types = require('../../../types-169d4b99.js');
require('../../../Picture/Image/index.js');
require('../../../browser.utils-bfcc05c6.js');
require('../../../typography/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var excludeTrimmingTags = new Set([types.ProductImageTag.DETAIL, types.ProductImageTag.SIZE_RELATION]);
var addPaddingTags = [types.ProductImageTag.INFO_GRAPHIC];
var getShortPath = function (src) {
    var key = 'simple';
    return "" + key + (src.split(key)[1] || '');
};
var useImageTagFormatter = function (tag, staticCmsHost, isRegularImgWithNeedToAddPaddings, isImageServiceProductImageEnabled, options
) {
    if (options === void 0) { options = { webP: false, padding: true, isTrimmed: true }; }
    var addedPaddingTags = React.useMemo(function () { return (isRegularImgWithNeedToAddPaddings ? tslib_es6.__spreadArrays(addPaddingTags, [types.ProductImageTag.REGULAR]) : addPaddingTags); }, [isRegularImgWithNeedToAddPaddings]);
    if (!isRegularImgWithNeedToAddPaddings) {
        excludeTrimmingTags.add(types.ProductImageTag.REGULAR);
    }
    var _a = options.webP, webP = _a === void 0 ? false : _a, _b = options.padding, padding = _b === void 0 ? true : _b, _c = options.isTrimmed, isTrimmed = _c === void 0 ? true : _c, _d = options.isLimited, isLimited = _d === void 0 ? false : _d;
    var resizeConfigurations = {
        padding: padding,
        removeText: isImageServiceProductImageEnabled,
        isTrimmed: isTrimmed && !excludeTrimmingTags.has(tag),
        isLimited: isLimited,
    };
    var isImageWithPadding = addedPaddingTags.includes(tag);
    var formatImage = function (src, imageWidth, imageSizeInfo) {
        var path = src;
        if (path.startsWith('http')) {
            path = getShortPath(path);
        }
        var desiredImageWidth = imageWidth;
        var sizeInfo = imageSizeInfo || useImageTagFormatter$1.getImageSizeInfo(desiredImageWidth);
        var paddingSize = isImageWithPadding ? sizeInfo.padding : undefined;
        var imageDimension = tslib_es6.__assign(tslib_es6.__assign({}, sizeInfo.size), { paddingSize: paddingSize });
        var webpSrc = useImageTagFormatter$1.preFormatImage(path, staticCmsHost, tslib_es6.__assign(tslib_es6.__assign(tslib_es6.__assign({}, resizeConfigurations), imageDimension), { webP: webP }));
        var jpegSrc = useImageTagFormatter$1.preFormatImage(path, staticCmsHost, tslib_es6.__assign(tslib_es6.__assign({}, resizeConfigurations), imageDimension));
        return { webpSrc: webpSrc, jpegSrc: jpegSrc };
    };
    return formatImage;
};

var useGetImageSources = function (src, tag, staticCmsHost, hasOverlay, isHero, options
) {
    var formatter = useImageTagFormatter(tag, staticCmsHost, hasOverlay, false, options);
    var _a = formatter(src, imageWidths.IMAGE_WIDTHS.PLP_IPHONE_X, isHero
        ? imageSizeConfigs.getPLPHeroImageSizeInfo(imageWidths.IMAGE_WIDTHS.PLP_HERO_IPHONE_X, tag)
        : imageSizeConfigs.getPLPImageSizeInfo(imageWidths.IMAGE_WIDTHS.PLP_IPHONE_X)), iphoneXSrcWebp = _a.webpSrc, iphoneXSrcJpeg = _a.jpegSrc;
    var _b = formatter(src, imageWidths.IMAGE_WIDTHS.PLP_MOBILE_LOW_DENSITY, isHero
        ? imageSizeConfigs.getPLPHeroImageSizeInfo(imageWidths.IMAGE_WIDTHS.PLP_HERO_MOBILE_LOW_DENSITY, tag)
        : imageSizeConfigs.getPLPImageSizeInfo(imageWidths.IMAGE_WIDTHS.PLP_MOBILE_LOW_DENSITY)), mobileSrcWebp = _b.webpSrc, mobileSrcJpeg = _b.jpegSrc;
    var _c = formatter(src, imageWidths.IMAGE_WIDTHS.PLP_MOBILE_HIGH_DENSITY, isHero
        ? imageSizeConfigs.getPLPHeroImageSizeInfo(imageWidths.IMAGE_WIDTHS.PLP_HERO_MOBILE_HIGH_DENSITY, tag)
        : imageSizeConfigs.getPLPImageSizeInfo(imageWidths.IMAGE_WIDTHS.PLP_MOBILE_HIGH_DENSITY)), mobileSrcWebp2xDpi = _c.webpSrc, mobileSrcJpeg2xDpi = _c.jpegSrc;
    var _d = formatter(src, imageWidths.IMAGE_WIDTHS.PLP_DESKTOP_TABLET_LOW_DENSITY, imageSizeConfigs.getPLPImageSizeInfo(imageWidths.IMAGE_WIDTHS.PLP_DESKTOP_TABLET_LOW_DENSITY)), desktopTabletWebpSrc = _d.webpSrc, desktopTabletJpegSrc = _d.jpegSrc;
    var _e = formatter(src, imageWidths.IMAGE_WIDTHS.PLP_DESKTOP_TABLET_HIGH_DENSITY, imageSizeConfigs.getPLPImageSizeInfo(imageWidths.IMAGE_WIDTHS.PLP_DESKTOP_TABLET_HIGH_DENSITY)), desktopTabletWebp2xDpiSrc = _e.webpSrc, desktopTabletJpeg2xDpiSrc = _e.jpegSrc;
    var _f = formatter(src, imageWidths.IMAGE_WIDTHS.PLP_DESKTOP_WIDE_SCREEN_LOW_DENSITY, imageSizeConfigs.getPLPImageSizeInfo(imageWidths.IMAGE_WIDTHS.PLP_DESKTOP_WIDE_SCREEN_LOW_DENSITY)), desktopWideScreenWebpSrc = _f.webpSrc, desktopWideScreenJpegSrc = _f.jpegSrc;
    var _g = formatter(src, imageWidths.IMAGE_WIDTHS.PLP_DESKTOP_WIDE_SCREEN_HIGH_DENSITY, imageSizeConfigs.getPLPImageSizeInfo(imageWidths.IMAGE_WIDTHS.PLP_DESKTOP_WIDE_SCREEN_HIGH_DENSITY)), desktopWideScreenWebp2xDpiSrc = _g.webpSrc, desktopWideScreenJpeg2xDpiSrc = _g.jpegSrc;
    var tabletSource2xDpi = Picture_index.jpegBackupSource({
        media: viewport_utils.getMediaStringValue('breakpointTablet', true),
        url: mobileSrcWebp2xDpi,
        value: 2,
        format: Picture_index.ImageFormat.WEBP,
    }, mobileSrcJpeg2xDpi);
    var sources = tslib_es6.__spreadArrays(Picture_index.jpegBackupSource({
        media: viewport_utils.iphoneXMediaQuery,
        url: iphoneXSrcWebp,
        value: 1,
        format: Picture_index.ImageFormat.WEBP,
    }, iphoneXSrcJpeg), Picture_index.jpegBackupSource({
        media: viewport_utils.getMediaStringValue('breakpointTablet', true),
        url: mobileSrcWebp,
        value: 1,
        format: Picture_index.ImageFormat.WEBP,
    }, mobileSrcJpeg), tabletSource2xDpi, Picture_index.jpegBackupSource({
        media: viewport_utils.getMediaStringValue('breakpointTablet'),
        url: desktopTabletWebpSrc,
        value: 1,
        format: Picture_index.ImageFormat.WEBP,
    }, desktopTabletJpegSrc), Picture_index.jpegBackupSource({
        media: viewport_utils.getMediaStringValue('breakpointTablet'),
        url: desktopTabletWebp2xDpiSrc,
        value: 2,
        format: Picture_index.ImageFormat.WEBP,
    }, desktopTabletJpeg2xDpiSrc), Picture_index.jpegBackupSource({
        media: viewport_utils.getMediaStringValue('breakpointSemiWideScreens'),
        url: desktopWideScreenWebpSrc,
        value: 1,
        format: Picture_index.ImageFormat.WEBP,
    }, desktopWideScreenJpegSrc), Picture_index.jpegBackupSource({
        media: viewport_utils.getMediaStringValue('breakpointSemiWideScreens'),
        url: desktopWideScreenWebp2xDpiSrc,
        value: 2,
        format: Picture_index.ImageFormat.WEBP,
    }, desktopWideScreenJpeg2xDpiSrc));
    return [sources, tabletSource2xDpi];
};

var logImageErrorWarning = function (url, tag, logger, customData) {
    logger.warn("[" + tag + "] Image with src - \"" + url + "\" failed to load", customData);
};
var imageGreyOverlay = styled.css(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n    &:after {\n        position: absolute;\n        content: ' ';\n        width: 100%;\n        height: 100%;\n        background: ", ";\n        top: 0;\n        left: 0;\n        pointer-events: none;\n    }\n"], ["\n    &:after {\n        position: absolute;\n        content: ' ';\n        width: 100%;\n        height: 100%;\n        background: ", ";\n        top: 0;\n        left: 0;\n        pointer-events: none;\n    }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.skeleton01;
});
var StyledProductImage = styled__default['default'](Product_ProductImage_index.ProductImage).withConfig({ displayName: "ww-uikit_StyledProductImage_loy4z7ah", componentId: "sc-nuf2vi" })(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n    position: relative;\n    overflow: hidden;\n"], ["\n    position: relative;\n    overflow: hidden;\n"])));
var StyledProductPicture = styled__default['default'](Picture_index['default']).withConfig({ displayName: "ww-uikit_StyledProductPicture_loy4z7ah", componentId: "sc-1wmtk7x" })(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n    position: absolute;\n"], ["\n    position: absolute;\n"])));
var SvgImageFillerBase = styled__default['default'].svg.withConfig({ displayName: "ww-uikit_SvgImageFillerBase_loy4z7ah", componentId: "sc-17hi0xu" })(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["\n    width: 100%;\n    height: 100%;\n    fill: transparent;\n\n    display: block;\n"], ["\n    width: 100%;\n    height: 100%;\n    fill: transparent;\n\n    display: block;\n"])));
var SvgImageFiller = function () { return (React__default['default'].createElement(SvgImageFillerBase, { viewBox: "0 0 3 4", xmlns: "http://www.w3.org/2000/svg" },
    React__default['default'].createElement("rect", { width: "3", height: "4" }))); };
var imageLoadErrorFunction = function (e, logger, tag, customData
) {
    logImageErrorWarning(e.currentTarget.currentSrc, tag, logger, customData);
};
var ProductTileImage = function (_a) {
    var product = _a.product, isHero = _a.isHero, imageConfigs = _a.imageConfigs, _b = _a.hasOverlay, hasOverlay = _b === void 0 ? true : _b, _c = _a.isWebPImage, isWebPImage = _c === void 0 ? false : _c;
    var altTag = product.altTag, simpleSku = product.simpleSku, name = product.name, productImage = product.productImage, bestSellingImage = product.bestSellingImage;
    var loading = imageConfigs.loading, testId = imageConfigs.testId, className = imageConfigs.className, logger = imageConfigs.logger, staticCmsHost = imageConfigs.staticCmsHost;
    var imageData = (bestSellingImage === null || bestSellingImage === void 0 ? void 0 : bestSellingImage.path) ? bestSellingImage : productImage;
    var tag = imageData.tag, seoSrc = imageData.seoUrl, path = imageData.path;
    var errorFunction = function (e) {
        var customData = {
            product: name,
            simpleSku: simpleSku,
        };
        return imageLoadErrorFunction(e, logger, 'PLP', customData);
    };
    var _d = useGetImageSources(path, tag, staticCmsHost, hasOverlay, isHero, {
        webP: isWebPImage,
    }), sources = _d[0], fallbackSource = _d[1];
    var seoUrl = seoSrc;
    if (!seoSrc.includes('/t_default.plp_seo')) {
        seoUrl = fallbackSource[0].url;
    }
    var fallback = { url: seoUrl, alt: altTag };
    return (React__default['default'].createElement(StyledProductImage, { className: className, "data-testid": testId },
        React__default['default'].createElement(StyledProductPicture, { "$hasOverlay": hasOverlay, sources: sources, loading: loading, fallback: fallback, errorFunction: errorFunction }),
        React__default['default'].createElement(SvgImageFiller, null)));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;

exports.ProductTileImage = ProductTileImage;
exports.imageGreyOverlay = imageGreyOverlay;
exports.imageLoadErrorFunction = imageLoadErrorFunction;
exports.logImageErrorWarning = logImageErrorWarning;
//# sourceMappingURL=index.js.map
